export interface RoxotEvent {
    eventCode: string;
    isHead?: boolean;
}

export const sendRoxotEvent = ({ eventCode, isHead }: RoxotEvent): HTMLImageElement => {
    const pixel = new Image();
    pixel.src = `https://rap.skcrtxr.com/pub/pix/${eventCode}?t=${Date.now()}`;
    pixel.style.display = 'none';
    return isHead ? document.head.appendChild(pixel) : document.body.appendChild(pixel);
};
